export enum CalendarType {
  Accounting = "ACCOUNTING",
  Compliance = "COMPLIANCE",
  Holiday = "HOLIDAY",
  Invoicing = "INVOICING",
  Payable = "PAYABLE",
  Payroll = "PAYROLL",
  Timesheet = "TIMESHEET",
  OrgBilling = "ORG_BILLING"
}